import React from "react";
import { ChatCircleDots, Clock, Users } from "phosphor-react"; // Placeholder icons

interface AboutFlirtyBumSectionProps {
  className?: string;
}

export default function AboutFlirtyBumSection({
  className,
}: AboutFlirtyBumSectionProps) {
  return (
    <section className={`py-16 px-4 text-center text-white ${className}`}>
      <h2 className="text-3xl md:text-4xl font-bold mb-12 text-white">
        About FlirtyBum
      </h2>
      <div className="w-[50dvw] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {/* Stat Box 1: Total Messages Sent */}
        <div className="flex flex-col items-center p-6 rounded-lg shadow-md bg-text">
          {" "}
          {/* Darker pink/purple background */}
          <div className="mb-4 text-[#C0123E]/80">
            <ChatCircleDots size={64} weight="duotone" />
          </div>
          <p className="text-4xl md:text-5xl font-bold mb-2">2,157+</p>
          <p className="text-lg">Messages Sent Daily</p>
        </div>

        {/* Stat Box 2: Total Conversations Started */}
        <div className="flex flex-col items-center p-6 rounded-lg shadow-md bg-[#C0123E]">
          <div className="mb-4 text-text">
            <ChatCircleDots size={64} weight="duotone" /> {/* Changed icon */}
          </div>
          <p className="text-4xl md:text-5xl font-bold mb-2">80,000+</p>{" "}
          {/* Placeholder number */}
          <p className="text-lg">Conversations Started</p> {/* Updated text */}
        </div>

        {/* Stat Box 3: Total Members (Placeholder, as user didn't want men/women online) */}
        <div className="flex flex-col items-center p-6 rounded-lg shadow-md bg-text">
          <div className="mb-4 text-[#C0123E]/80">
            <Users size={64} weight="duotone" />
          </div>
          <p className="text-4xl md:text-5xl font-bold mb-2">10,000+</p>{" "}
          {/* Placeholder number */}
          <p className="text-lg">Active Members</p>
        </div>
      </div>
    </section>
  );
}
